import { graphql } from '~/lib/graphql'

export const RestaurantSearchCourse = graphql(/* GraphQL */ `
  fragment RestaurantSearchCourse on Course {
    ...CourseSelectionInfo
    searchPlans(input: $searchInput) {
      edges {
        seats {
            ...SeatAttributes
        }
        node {
          ...PlanSelectionInfo
          ...PlanAttributes
          searchPrice(input: $searchInput) {
            ...PlanSearchPrice
          }
        }
      }
    }
  }
`)
